module.exports = __webpack_public_path__ + "img/previewbtn.6b64a7b9.png";